import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import engine from '../../static/img/engine.png';
import killometers from '../../static/img/killometers48.png';
import piston from '../../static/img/piston48.png';
import transmission from '../../static/img/transmission.png';
import greece_map from '../../static/img/greece_map.png';
import cyprus_map from '../../static/img/cyprus_map.png';
import calendar from '../../static/img/calendar48.png';
import model from '../../static/img/model.png';
import modelTruck from '../../static/img/truck48.png';
import modelOther from '../../static/img/other48.png';
import modelMoto from '../../static/img/motocyrcle48.png';
import modelPickup from '../../static/img/pickup48.png';
import noImg from '../../static/img/notAvailable.png';

import { getBrand } from 'lib/Utils';
import { kilometers } from 'vdlib';

import {
  isNil,
  ifNullOrWhitespace,
  PartyTypes,
  AuctionStatuses,
  formatCurrency,
  toDateTimeString,
} from 'vdlib';

import LookupsHelper from 'lib/LookupsHelper';

import { Card, Row, Typography, Descriptions, Col, Alert, Icon } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

const defaultClassName = 'col-12';

const { Meta } = Card;

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

const gridStyle = {
  width: '50%',
  height: '120px',
  textAlign: 'center',
};

const imageStyle = {
  height: '48px',
  width: '48px',
  textAlign: 'center',
};

const titleStyle = {
  fontWeight: 400,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.45)',
};

const descriptionStyle = {
  fontWeight: 500,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.85)',
};

const PartDataPane = ({
  auction,
  className,
  partyType,
  viewOnly,
  showInsurance,
  status,
  comments,
}) => {
  if (!auction) return <div className="row" />;

  return (
    <div
      className={`auction-data-pane ${ifNullOrWhitespace(
        className,
        defaultClassName
      )}`}
    >
      <Row>
        <Col xs={24}>
          <Card
            headStyle={{ background: '#efefef' }}
            title={
              <div>
                <span>
                  <SettingOutlined
                    style={{
                      fontSize: 22,
                      color: '#6d6d6d',
                      verticalAlign: '0em',
                      marginRight: 5,
                    }}
                  />
                </span>
                <span
                  style={{ fontSize: 18, fontWeight: 600, color: '#6d6d6d' }}
                >
                  {`${I.t('PART_DATA')}`}
                </span>
              </div>
            }
          >
            <Descriptions
              className="profile"
              colon={false}
              column={1}
              size="small"
              bordered
            >
              <Descriptions.Item label={I.t('PART_NUMBER')}>
                <span style={descriptionDetailsStyle}>
                  {auction.PartNumber}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('DESCRIPTION')}>
                <span style={descriptionDetailsStyle}>
                  {auction.PartDescription}
                </span>
              </Descriptions.Item>
              {partyType === PartyTypes.Merchant ? (
                ''
              ) : (
                <Descriptions.Item label={I.t('INITIAL_PRICE_SHORT')}>
                  <span style={descriptionDetailsStyle}>
                    {formatCurrency(auction.PartPrice)}
                  </span>
                </Descriptions.Item>
              )}
              {partyType !== PartyTypes.Merchant &&
              status === AuctionStatuses.Pending ? (
                <div>
                  <Descriptions.Item label={I.t('PRICE_NEW_TARGET')}>
                    <span style={descriptionDetailsStyle}>
                      {' '}
                      {isNil(auction.NewTargetPartPrice)
                        ? 'N/A'
                        : formatCurrency(auction.NewTargetPartPrice)}{' '}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('PRICE_USED_TARGET')}>
                    <span style={descriptionDetailsStyle}>
                      {' '}
                      {isNil(auction.UsedTargetPartPrice)
                        ? 'N/A'
                        : formatCurrency(auction.UsedTargetPartPrice)}{' '}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={I.t('PRICE_IMITATION_TARGET')}
                    span={2}
                  >
                    <span style={descriptionDetailsStyle}>
                      {' '}
                      {isNil(auction.ImitationTargetPartPrice)
                        ? 'N/A'
                        : formatCurrency(auction.ImitationTargetPartPrice)}{' '}
                    </span>
                  </Descriptions.Item>
                </div>
              ) : (
                ''
              )}
              <Descriptions.Item
                label={I.t('QUANTITY')}
                span={partyType !== PartyTypes.Merchant ? 1 : 2}
              >
                <span style={descriptionDetailsStyle}>{auction.Quantity}</span>
              </Descriptions.Item>
              <Descriptions.Item
                label={`${I.t('COMMENTS')} - ${I.t('FROM')}: ${
                  comments ? comments.SenderName : ''
                }`}
                span={2}
              >
                <span style={descriptionDetailsStyle}>
                  {comments ? comments.Comments : ''}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>

      {showInsurance !== false ? (
        <div className="auction-data-pane-footer">
          {auction.CreatedPartyID === auction.ExpertID ? (
            <div>
              <div className="pull-left">
                {I.t('CREATE_FROM')}{' '}
                <span className="bold">
                  {`${LookupsHelper.getDescription(
                    'experts',
                    auction.ExpertID
                  )} ${I.t('FOR')} ${LookupsHelper.getDescription(
                    'insurances',
                    auction.InsuranceID
                  )}`}
                </span>
              </div>
            </div>
          ) : (
            <div className="pull-left">
              {I.t('CREATE_FROM')}{' '}
              <span className="bold">
                {LookupsHelper.getDescription(
                  'insurances',
                  auction.InsuranceID
                )}
              </span>
            </div>
          )}
          <br />
          <div className="float-left">
            {toDateTimeString(auction.CreatedDate)}
          </div>
        </div>
      ) : (
        false
      )}
    </div>
  );
};

PartDataPane.propTypes = {
  auction: PropTypes.object,
  className: PropTypes.string,
  partyType: PropTypes.string,
  viewOnly: PropTypes.bool,
  status: PropTypes.string,
};

export default PartDataPane;
